import React, { useEffect, useState } from 'react'
import { globalHistory } from '@reach/router'
import styled from '@emotion/styled'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down.svg'
import { H3 } from '../../components/shared/type'
import Dropdown from '../shared/dropdown'

const DropdownToggle = styled(H3)`
  display: inline-block;
  position: relative;
  cursor: pointer;
  margin: 0;
  padding-right: ${p => p.theme.space[5]};
`

const Arrow = styled(({ direction, ...props }) => <ArrowIcon {...props} />)`
  position: absolute;
  top: 50%;
  right: -5px;
  transform: ${p =>
    p.direction === 'top'
      ? 'translate(-50%, -50%) rotate(180deg)'
      : 'translate(-50%, -50%) rotate(0deg)'};
  width: 15px;
  height: 15px;
`

const GroupDropdown = ({ children, ...rest }) => {
  const [opened, setOpened] = useState(false)
  const toggleOpened = () => setOpened(prevOpened => !prevOpened)
  const hide = () => setOpened(false)

  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === 'PUSH') {
        hide()
      }
    })
  }, [])

  return (
    <Dropdown visible={opened} onClickOutside={hide} {...rest}>
      <DropdownToggle onClick={toggleOpened}>
        {children}
        <Arrow direction={opened ? 'top' : 'down'} />
      </DropdownToggle>
    </Dropdown>
  )
}

export default GroupDropdown
